import { c as _c } from "react/compiler-runtime";
import MuiLink, { LinkProps } from '@mui/material/Link';
import { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import { HTMLAttributeAnchorTarget, ReactElement } from 'react';
type ValueOf<T> = T[keyof T];
interface FooterLinkProps {
  url: string;
  label: string;
  variant?: ValueOf<Pick<LinkProps, 'variant'>>;
  underline?: ValueOf<Pick<LinkProps, 'underline'>>;
  src?: string;
  width?: number;
  height?: number;
  target?: HTMLAttributeAnchorTarget;
  noFollow?: boolean;
  sx?: SxProps<Theme>;
}
export function FooterLink(t0) {
  const $ = _c(20);
  const {
    url,
    label,
    variant: t1,
    underline: t2,
    src,
    width,
    height,
    target,
    noFollow: t3,
    sx
  } = t0;
  const variant = t1 === undefined ? "h6" : t1;
  const underline = t2 === undefined ? "none" : t2;
  const noFollow = t3 === undefined ? false : t3;
  const t4 = noFollow ? "nofollow noopener" : "noopener";
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "text.primary"
    };
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== src || $[2] !== sx) {
    t6 = src != null && sx != null ? Array.isArray(sx) ? sx : [sx] : [];
    $[1] = src;
    $[2] = sx;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t6) {
    t7 = [t5, ...t6];
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== height || $[7] !== label || $[8] !== src || $[9] !== sx || $[10] !== variant || $[11] !== width) {
    t8 = src == null ? <Typography variant={variant} sx={sx}>{label}</Typography> : <Image src={src} width={width ?? 32} height={height ?? 32} alt={label} style={{
      maxWidth: "100%",
      height: "auto"
    }} />;
    $[6] = height;
    $[7] = label;
    $[8] = src;
    $[9] = sx;
    $[10] = variant;
    $[11] = width;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t7 || $[15] !== t8 || $[16] !== target || $[17] !== underline || $[18] !== url) {
    t9 = <MuiLink href={url} underline={underline} target={target} rel={t4} data-testid="FooterLink" sx={t7}>{t8}</MuiLink>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
    $[16] = target;
    $[17] = underline;
    $[18] = url;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}